<template>
  <div class="form-card">
    <div class="form-card__header justify-content-center">
      <h2 class="form-card__title">Totales de la factura</h2>
    </div>
    <div class="form-card__body">
      <div v-if="myTotals" class="row">
        <div class="col-md-3 form-card__field">
          <label class="form-card__label">Total bruto</label>
          <input type="text" class="form-control" placeholder="$ 0,00" v-model="myTotals.gross"/>
        </div>
        <div class="col-md-1 form-card__field">
          <label class="form-card__label">IVA 2,5</label>
          <input type="text" class="form-control" placeholder="$ 0,00" v-model="myTotals.taxes.two"/>
        </div>
        <div class="col-md-1 form-card__field">
          <label class="form-card__label">IVA 5</label>
          <input type="text" class="form-control" placeholder="$ 0,00" v-model="myTotals.taxes.five"/>
        </div>
        <div class="col-md-1 form-card__field">
          <label class="form-card__label">IVA 10,5</label>
          <input type="text" class="form-control" placeholder="$ 0,00" v-model="myTotals.taxes.ten"/>
        </div>
        <div class="col-md-1 form-card__field">
          <label class="form-card__label">IVA 21</label>
          <input type="text" class="form-control" placeholder="$ 0,00" v-model="myTotals.taxes.twentyOne"/>
        </div>
        <div class="col-md-1 form-card__field">
          <label class="form-card__label">IVA 27</label>
          <input type="text" class="form-control" placeholder="$ 0,00" v-model="myTotals.taxes.twentySeven"/>
        </div>
        <div class="col-md-2 form-card__field">
          <label class="form-card__label">Excento</label>
          <input type="text" class="form-control" placeholder="$ 0,00" v-model="myTotals.taxes.lofty"/>
        </div>
        <div class="col-md-2 form-card__field">
          <label class="form-card__label">Descuento</label>
          <input type="text" class="form-control" placeholder="$ 0,00" v-model="myTotals.discount"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 form-card__field">
          <label class="form-card__label">Impuestos internos</label>
          <input type="text" class="form-control" placeholder="$ 0,00" v-model="myTotals.taxes.internalTax"/>
        </div>
        <div class="col-md-2 form-card__field">
          <label class="form-card__label">Percepcion IVA</label>
          <input type="text" class="form-control" placeholder="$ 0,00" v-model="myTotals.taxes.perceptionTax"/>
        </div>
        <div class="col-md-2 form-card__field">
          <label class="form-card__label">Perc. IIBB</label>
          <input type="text" class="form-control" placeholder="$ 0,00" v-model="myTotals.taxes.iibb"/>
        </div>
        <div class="col-md-2 form-card__field">
          <label class="form-card__label">Otros impuestos</label>
          <input type="text" class="form-control" placeholder="$ 0,00" v-model="myTotals.taxes.otherTax"/>
        </div>
        <div class="col-md-4 form-card__field">
          <label class="form-card__label">Total</label>
          <input type="text" class="form-control" placeholder="$ 0,00" v-model="myTotals.total"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: ['company_typetax', 'endpointurl', 'showChoosedate', 'payment_methods', 'totals'],
    data() {
      return {
        myTotals: {
          gross: 0,
          taxes: {
            two: 0,
            five: 0,
            ten: 0,
            twentyOne: 0,
            twentySeven: 0,
            lofty: 0,
            internalTax: 0,
            perceptionTax: 0,
            iibb: 0,
            otherTax: 0
          },
          total: 0,
          discount:0
        }
      }
    },
    mounted: function () {
      this.myTotals = this.totals;
    },
    watch: {
      'myTotals': { // Esto envia los datos de header cada vez que cambian al receipt donde seran adjuntados al payload
        handler: function () {
          this.$emit('totalschanged', this.myTotals);
        }, deep: true,
      },
    }
}
</script>
<style>

</style>
